/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Rounds_Round_In_ProgressInputs */



/**
* | output |
* | --- |
* | "Round {n} in progress" |
*
* @param {Rounds_Round_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_round_in_progress = /** @type {((inputs: Rounds_Round_In_ProgressInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Round_In_ProgressInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ronde ${i?.n} en cours`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Ronda ${i?.n} en progreso`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Rodada ${i?.n} em andamento`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Round ${i?.n} in corso`)
	return /** @type {LocalizedString} */ (`Round ${i?.n} in progress`)
});